import { ArrowRightIcon } from '@grupoboticario/flora-react-icons';
import { Cta } from './Summary.components.styles';
import { SUMMARY_COMPONENTS_CONST } from './Summary.components.d';
import type { ButtonCtaProps } from './Summary.components.d';

const ButtonCtaBase = ({ label, onClick }: ButtonCtaProps) => (
  <Cta.ButtonWrapper>
    <Cta.ButtonContainer>
      <Cta.Button
        data-testid={SUMMARY_COMPONENTS_CONST.CTA_TEST_ID}
        onClick={onClick}
        stretch
        variant="conversion"
        tabIndex={0}
        aria-label={label}
      >
        {label} <ArrowRightIcon size={12} />
      </Cta.Button>
    </Cta.ButtonContainer>
  </Cta.ButtonWrapper>
);

export default ButtonCtaBase;
